export class RouteNames {
  static readonly IdentityManagement = 'AbpIdentity::Menu:IdentityManagement';
  static readonly LanguagesPage = 'LanguageManagement::Languages';
}
